import * as Sentry from "@sentry/react";
Sentry.init({
    dsn: "https://ff63b200207e2f083f1f499f2d3f02b8@o4510472431927296.ingest.us.sentry.io/4510480644898816",
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});